import axios from 'axios';
import { config } from '../../config';
import { adminAuthHeaders } from './authHeaders';

export async function getAdminClasses(params = {}) {
    const host = `${config.service.host}/api/admin`;
    const headers = await adminAuthHeaders();
    const { data } = await axios.get(`${host}/classes`, {
        params,
        headers,
    });
    return data;
}

export async function getAdminClass(cid) {
    const host = `${config.service.host}/api/admin`;
    const headers = await adminAuthHeaders();
    const { data } = await axios.get(`${host}/classes/${cid}`, {
        headers,
    });
    return data;
}

// Manual matching (creating a new class from a teacher+student pick) now
// lives in ./matching.js (createAdminMatch) — see admin/matching.routes.js
// on the backend. This file's old postClassMatchStub assumed an existing
// class row to "confirm" via :cid/match, which doesn't fit that use case.

// Sends the match notification emails for already-created classes. Separate from
// match creation on purpose — a coordinator decides when a cohort is settled
// enough to tell people about. `force` re-sends classes already marked notified.
export async function sendAdminClassNotifications(cids, force = false) {
    const host = `${config.service.host}/api/admin`;
    const headers = await adminAuthHeaders();
    const { data } = await axios.post(`${host}/classes/notify`, { cids, force }, {
        headers,
    });
    return data;
}
